import { TOTAL_DE_PASOS } from '@pasos/schemas';
import { Logo } from '../components/domain/Logo.js';
import { Stepper as Pasos } from '../components/domain/Stepper.js';
import { PACIENTE } from '../copy/index.js';

/**
 * El encabezado del onboarding: logo, avance por pasos y "Paso 2 de 4".
 *
 * El avance es una lista con `aria-current="step"` y una frase por paso para el
 * lector de pantalla —"paso 2, actual"—, no una fila de puntos pintados. El texto
 * "Paso 2 de 4" también está escrito, y no sólo implícito en el color: WCAG
 * 1.4.1, el color no puede ser el único medio para transmitir información.
 *
 * E3.8.2, contra la referencia P-02a a P-02d: el stepper pasa a círculos con
 * número, tilde y línea, y el logo navy abre la pantalla. El título de cada paso
 * ya no vive acá: lo pone cada paso, porque en el primero lo dice PIA.
 */
export function Stepper({ paso }: { paso: number }) {
  return (
    <header className="flex shrink-0 flex-col gap-5 bg-card px-5 pt-6 pb-4">
      <Logo className="h-9.5 w-auto self-start" fondo="claro" />
      <Pasos
        actual={paso}
        etiqueta={PACIENTE.onboarding.progresoParaLector}
        textoDelPaso={(numero, estado) =>
          estado === 'actual'
            ? PACIENTE.onboarding.pasoActualParaLector(numero)
            : PACIENTE.onboarding.pasoParaLector(numero)
        }
        total={TOTAL_DE_PASOS}
      />
      <p className="m-0 text-base font-medium text-subtle">
        {PACIENTE.onboarding.paso(paso, TOTAL_DE_PASOS)}
      </p>
    </header>
  );
}

/** El título de un paso, en serif. */
export function TituloDelPaso({ children }: { children: string }) {
  return <h1 className="m-0 font-serif text-display-md font-regular text-heading">{children}</h1>;
}
